/* unplugin-vue-components disabled */import { render } from "./DriverList.vue?vue&type=template&id=36a5ba67"
import script from "./DriverList.vue?vue&type=script&lang=js"
export * from "./DriverList.vue?vue&type=script&lang=js"

import "./DriverList.vue?vue&type=style&index=0&id=36a5ba67&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__